import { WorkflowMessage, WorkflowStatusMessage } from 'interfaces-lib';
import { MessageNotificationService } from 'message-notification-service-lib';
import { WorkflowTask } from 'workflow-task-service-lib';
import { TaskCompleteCallback } from '../services/save-as-docx.service';

export interface ISaveAsDocxTaskConfig {
  inputText: string;
  outputFileName: string;
  fileType: string;
  entity: { id: string; type: string };
}

enum MessageType {
  ERROR_EVENT = 'ErrorEvent',
  WORKFLOW_STATUS = 'WorkflowStatus',
}

export class SaveAsDocxTask extends WorkflowTask {
  static readonly TASK_COMPLETE_STATUS = 'AiAssistSaveToEntityComplete';

  constructor(
    private config: ISaveAsDocxTaskConfig,
    private taskCompleteCallback: TaskCompleteCallback,
    private messageNotificationService: MessageNotificationService
  ) {
    super('AI_ASSIST_SAVE_TO_ENTITY');
  }

  override getStartParams(): any {
    return {
      inputText: this.config.inputText,
      outputFilename: this.config.outputFileName,
      outputFileType: this.config.fileType, // this is the "new" format
      destination: [
        { namespace: 'bullhorn', path: [this.config.entity.type, this.config.entity.id] },
      ],
    };
  }

  override workflowStartSuccess() {}

  override receive(message: WorkflowMessage): boolean {
    console.log('Message from server: ', message);

    if (message.type === MessageType.ERROR_EVENT) {
      this.messageNotificationService.error(message.message);
      this.taskCompleteCallback();
      return true;
    }

    if (message.type === MessageType.WORKFLOW_STATUS) {
      if ((<WorkflowStatusMessage>message.message).status === SaveAsDocxTask.TASK_COMPLETE_STATUS) {
        this.messageNotificationService.success('Prompt successfully saved to entity.');
        this.taskCompleteCallback();
        return true;
      }
    }

    return false;
  }
}
